import React from 'react';
import { FormattedMessage } from 'react-intl';

export const FeedbackPage: React.FC = () => {
  return (
    <div>
      <FormattedMessage id="feedback.header" />
    </div>
  );
};

export default FeedbackPage;
